const appLocales = require('../../../.locales.json');

module.exports.getMomentLocales = function getMomentLocales() {
  return appLocales.map(locale => (locale.momentCode || locale.code).toLowerCase());
};
